export const hasNotifications = data => {
  let flagged = false
  for (let i = 0; i < data.length; i++) {
    if (data[i] === "flagged") {
      flagged = true
    }
  }
  return flagged
}
